<template>
    <div class="bg-white dark:bg-slate-800 rounded-lg shadow overflow-hidden">
        <div class="px-2 py-3">
            <h2 class="mb-3 px-3 font-medium dark:text-white">Recent Activity</h2>
            <ul class="divide-gray-100 dark:divide-gray-700 divide-y">
                <li v-for="item in data" :key="item.id">
                    <activity-item :item="item" />
                </li>
            </ul>
            <no-results :show="!data.length">No Activity Yet</no-results>
        </div>
    </div>
</template>

<script>
import ActivityItem from "@/Pages/Dashboard/ActivityItem"
import NoResults from "@/Jetstream/NoResults"

export default {
    components: { NoResults, ActivityItem },
    mounted() {
        Echo.channel("activityFeed").listen(".updated", (e) => this.$emit("update:data", e.activityFeed))
    },

    props: {
        data: {
            required: true,
            type: Array,
        },
    },
}
</script>
